<template>
  <div class="row">
    <div class="col-md-3">
      <label for="">Доставка с хладагентом</label>
      <div class="form-check">
        <input class="form-check-input" type="radio" id="r1" value="1" v-model="drug.cool">
        <label class="form-check-label" for="r1">Да</label>
      </div>
      <div class="form-check">
        <input class="form-check-input" type="radio" id="r2" value="0" v-model="drug.cool">
        <label class="form-check-label" for="r2">Нет</label>
      </div>
    </div>
    <div class="col-md-3">
      <label for="">Аэрозоль под давлением</label>
      <div class="form-check">
        <input class="form-check-input" type="radio" id="r_press_can" value="1" v-model="drug.is_press_can">
        <label class="form-check-label" for="r_press_can">Да</label>
      </div>
      <div class="form-check">
        <input class="form-check-input" type="radio" id="r_press_can" value="0" v-model="drug.is_press_can">
        <label class="form-check-label" for="r_press_can">Нет</label>
      </div>
    </div>
    <div class="col-md-3">
      <label for="">Льготная стоимость доставки</label>
      <div class="form-check">
        <input class="form-check-input" type="radio" id="r3" value="1" v-model="drug.lgot_price">
        <label class="form-check-label" for="r3">Да</label>
      </div>
      <div class="form-check">
        <input class="form-check-input" type="radio" id="r4" value="0" v-model="drug.lgot_price">
        <label class="form-check-label" for="r4">Нет</label>
      </div>
    </div>
    <div class="col-md-3">
      <label for="">Государственная регистрация</label>
      <div class="form-check">
        <input class="form-check-input" type="radio" id="r5" value="1" v-model="detail.use.value">
        <label class="form-check-label" for="r5">Да</label>
      </div>
      <div class="form-check">
        <input class="form-check-input" type="radio" id="r6" value="0" v-model="detail.use.value">
        <label class="form-check-label" for="r6">Нет</label>
      </div>
      <div v-if="+detail.use.value" class="flex">
        <select v-model="detail.type.value" class="form-control registration_type_select">
          <option value="0">Бессрочно</option>
          <option value="1">Дата окончания</option>
        </select>
        <div v-if="+detail.type.value === 1" class="ml-2">
          <DateSelectProps ref="selectedDate"
                           :disabled="false"
                           :useDisabledDates="false"
                           :selectedDate="detail.date.value"
                           :onSelect="(date) => this.detail.date.value = date"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import DateSelectProps from "@/components/dateSelect/DateSelectProps";

export default {
  props: ['drug', 'detail'],
  components: {
    DateSelectProps,
  }
}
</script>
